import { BirdviewChartObject } from '../DashboardBirdview.constants.charts'

export const BIRDVIEW_CHART_CATALOG_ALL_TAB = 'all'

export const BIRDVIEW_CHART_CATALOG_ALL_TAB_OPTION = {
  labelKey: 'DashboardBirdview.ChartCatalogAllTabKey',
  value: BIRDVIEW_CHART_CATALOG_ALL_TAB,
}

// The order of the tabs and of the groups in the list.
export const BIRDVIEW_CHART_CATALOG_OBJECTS = [
  {
    labelKey: 'DashboardBirdview.RequestsTitleKey',
    value: BirdviewChartObject.Requests,
  },
  {
    labelKey: 'DashboardBirdview.ChartObjectBuildingsKey',
    value: BirdviewChartObject.Buildings,
  },
  {
    labelKey: 'DashboardBirdview.ChartObjectUnitsKey',
    value: BirdviewChartObject.Units,
  },
  {
    labelKey: 'DashboardBirdview.ChartObjectCustomersKey',
    value: BirdviewChartObject.Customers,
  },
  {
    labelKey: 'DashboardBirdview.ChartObjectEmailsKey',
    value: BirdviewChartObject.Emails,
  },
  {
    labelKey: 'DashboardBirdview.DocFlowsTitleKey',
    value: BirdviewChartObject.DocFlows,
  },
]
